import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'metal text-navy-950 border border-silver-300 shadow-lg shadow-black/30 transition-[filter,transform] hover:brightness-110 active:scale-[0.98]',
    secondary: 'bg-navy-700 text-white border border-silver-400/40 shadow-md transition-[background-color,transform] hover:bg-navy-600 active:scale-[0.98]',
    outline: 'border-2 border-silver-300 bg-transparent text-silver-100 transition-colors hover:bg-navy-800'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-silver-300/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-262" data-mp="oq6on7a9hvxn">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="xos2ip4sgms3" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-264" data-mp="1cd54c2qk4zui">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-265" data-mp="17ds8wtlmekgb" />}
    </button>;
}